//index.js 

import React from 'react'
import ReactDom from 'react-dom'

import App from './App'

//render app component to the html 'root' element
ReactDom.render(<App />, document.getElementById('root'))
